import { minBy } from "lodash-es";

import type { ConnectedProjectDto } from "@/api/types";
import { getLocalStorageValue, updateLocalStorage } from "@/hooks/useLocalStorage";

import { LOCAL_STORAGE_KEYS } from "./storage";

export function setRecentProject(projectId: string): void {
  updateLocalStorage(LOCAL_STORAGE_KEYS.RECENT_PROJECT, projectId);
}

export function getRecentProject(projects: ConnectedProjectDto[]): ConnectedProjectDto {
  const recentProjectId = getLocalStorageValue(LOCAL_STORAGE_KEYS.RECENT_PROJECT, undefined);
  if (recentProjectId) {
    const recentProject = projects.find((p) => p.id === recentProjectId);
    if (recentProject) {
      return recentProject;
    }
  }

  return minBy(projects, (x) => x.name)!;
}
